import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';
import { RouterLink } from 'vue-router';
import { RouteName } from '@/router/routes';
import { Language } from '@/enums/language';
import TG4Button from "@/components/TG4Button.vue";
import { useStore } from "@/composables/useStore";
import { IconHome, IconLive, IconSearch, IconAccount, IconSettings, IconAdd } from '@/components/icons';
import { FocusElement, navigationService } from "vue-spatialnavigation";
import { railFocusMemory } from "@/helpers/railFocusMemory";
type IconComponent = typeof IconHome;

interface NavLink {
  id: string;
  routeName: RouteName;
  icon: IconComponent;
  translationKey: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NavNestedView',
  setup(__props) {

const { useGetter, dispatch } = useStore();
const currentLanguage = useGetter<Language>('currentLanguage');

const instance = getCurrentInstance();
const router = instance?.proxy?.$router;

const i18n = instance?.proxy?.$i18n;

//Fix for typing Vue components correctly
const navLinks: NavLink[] = [
  {
    id: 'nav-home',
    routeName: RouteName.Home,
    icon: IconHome,
    translationKey: 'general.home'
  },
  {
    id: 'nav-search',
    routeName: RouteName.Search,
    icon: IconSearch,
    translationKey: 'general.search'
  },
  {
    id: 'nav-discover',
    routeName: RouteName.Discover,
    icon: IconAdd,
    translationKey: 'general.discover'
  },
  {
    id: 'nav-live',
    routeName: RouteName.Live,
    icon: IconLive,
    translationKey: 'general.live'
  }
];

const languageToChangeToTitle = computed(() => {
  return currentLanguage.value === Language.English ? 'Gaeilge' : 'English';
});

const toggleLanguage = () => {
  const currentLang = currentLanguage.value;
  const newLang = currentLang === Language.English ? Language.Irish : Language.English;
  dispatch("CHANGE_LANGUAGE", newLang);
  if (i18n) {
    i18n.locale = currentLanguage.value.toUpperCase();
  }
};

const moveFocusToNestedView = () => {
  let elementToFocus: FocusElement | undefined;

  switch (router?.currentRoute.name) {
    case RouteName.Rails: {
      elementToFocus =
        navigationService.getFocusElementById(`rail-${railFocusMemory.get()}-0`)
        ?? navigationService.getFocusElementById("rail-0-0");

      break;
    }
    case RouteName.Discover: {
      elementToFocus = navigationService.getFocusElementById('discover-category-0')
        ?? navigationService.getFocusElementById('rail-0-0');
      break;
    }
    case RouteName.Search: {
      elementToFocus = navigationService.getFocusElementById('search-input');
      break;
    }
    case RouteName.Live: {
      elementToFocus = navigationService.getFocusElementById('stream-0');
      if (!elementToFocus) {
        elementToFocus = navigationService.getFocusElementById('epg-button');
      }
      break;
    }
    case RouteName.Welcome:
    case RouteName.Settings: {
      // const elementByClassName = document.getElementsByClassName('firstFocus')[0];
      // elementToFocus = navigationService.getFocusElementById(elementByClassName.id);
      elementToFocus = navigationService.getFocusElementById('faq-button');
      break;
    }
    case RouteName.Login: {
      elementToFocus = navigationService.getFocusElementById('login-button');
      break;
    }
    case RouteName.UserBookmarks: {
      elementToFocus = navigationService.getFocusElementById('nav-user-bookmarks');
      break;
    }
    case RouteName.UserHistory: {
      elementToFocus = navigationService.getFocusElementById('nav-user-history');
      break;
    }
    case RouteName.UserDetails: {
      elementToFocus = navigationService.getFocusElementById('nav-user-details');
      break;
    }
    default:
      break;
  }

  if (elementToFocus) {
    elementToFocus.focus();
    setTimeout(() => {
      // eslint-disable-next-line
      // @ts-ignore
      document.getElementById(elementToFocus?.id)?.focus();
    }, 200);
  }
};


return { __sfc: true,useGetter, dispatch, currentLanguage, instance, router, i18n, navLinks, languageToChangeToTitle, toggleLanguage, moveFocusToNestedView, RouterLink, RouteName, TG4Button, IconAccount, IconSettings }
}

})